export default __webpack_public_path__ + "static/media/helpIcon-filled.40f46777.svg";